import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import QuoteSOVButton from './quoteSOVButtons';
import { getPathVariables } from '../../misc';

import {
  DueMonthlyWrapper,
  DueNowWrapper,
  ButtonsWrapper,
  Button as StyledButtonWrapper,
  Flex,
  LabelDueMonthly,
  BeforeTaxesLabel,
  PricingBlockMain,
  IntegralPart,
  FractionalPart,
  Currency
} from './css';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const Desktop = ({
  isSendToSRT,
  isVBP,
  isFormTouched,
  isFormValidated,
  isOrderFulfillmentTeam,
  isSalesSupport,
  dueMonthly,
  dueNow,
  onSaveAndExit,
  onDownloadClick,
  onProceedClick,
  onValidateForm,
  onSendToSRT,
  onSubmitForApproval,
  hidePricing,
  isQuoteApproved,
  isSubmitting
}) => {
  const localizedStringsContext = useLocalizedStringsContext();
  const {
    ORDERS: {
      DUE_MONTHLY,
      DUE_NOW,
      BEFORE_TAXES,
      DOWNLOAD_THE_QUOTE,
      PROCEED_WITH_THE_ORDER,
      saveAndContinueLater,
      sendToSRT,
      submitForApproval,
      continueButton
    }
  } = localizedStringsContext;

  const getFormattedPricing = pricing => {
    const newPricing = pricing.replace('$', '');
    const locale = getPathVariables(window.location.pathname)[0];
    return (
      <>
        <IntegralPart>
          {newPricing.split('.')[0]}
          <FractionalPart>
            {locale === 'fr-CA' ? ',' : '.'}
            {newPricing.split('.')[1]}
          </FractionalPart>
        </IntegralPart>
        <Currency style={{ order: locale === 'fr-CA' ? '3' : '-1' }}>
          $
        </Currency>
      </>
    );
  };

  return (
    <div id="footer-high">
      <>
        {!hidePricing && (
          <>
            <DueMonthlyWrapper>
              <div>
                <LabelDueMonthly>{DUE_MONTHLY}</LabelDueMonthly>
                <PricingBlockMain>
                  {getFormattedPricing(dueMonthly)}
                </PricingBlockMain>
                <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
              </div>
            </DueMonthlyWrapper>
            <DueNowWrapper>
              <>
                <div>
                  <LabelDueMonthly>{DUE_NOW}</LabelDueMonthly>
                  <PricingBlockMain>
                    {getFormattedPricing(dueNow)}
                  </PricingBlockMain>
                  <BeforeTaxesLabel>{BEFORE_TAXES}</BeforeTaxesLabel>
                </div>
              </>
            </DueNowWrapper>
          </>
        )}

        {isOrderFulfillmentTeam ? (
          <QuoteSOVButton
            isFormTouched={isFormTouched}
            isFormValidated={isFormValidated}
            onDownloadClick={onDownloadClick}
            onProceedClick={onProceedClick}
            onValidateForm={onValidateForm}
            isSubmitting={isSubmitting}
          />
        ) : (
          <ButtonsWrapper>
            <Flex style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
              {isFormValidated && !isVBP && (
                <Button
                  type="button"
                  onClick={e => onDownloadClick(e)}
                  variant={{ priority: 'low' }}
                >
                  {DOWNLOAD_THE_QUOTE}
                </Button>
              )}
              {!isSendToSRT && !isVBP && isFormValidated && (
                <Button
                  type="button"
                  onClick={e => onProceedClick(e)}
                  variant={{ priority: 'high' }}
                  disabled={isSubmitting}
                >
                  {PROCEED_WITH_THE_ORDER}
                </Button>
              )}
              {isSendToSRT && !isVBP && isFormValidated && (
                <Button
                  type="button"
                  onClick={e => onSendToSRT(e)}
                  variant={{ priority: 'high' }}
                  disabled={isSubmitting}
                >
                  {sendToSRT}
                </Button>
              )}
              {!isFormValidated && !isVBP && (
                <Button
                  type="button"
                  onClick={e => onSaveAndExit(e)}
                  variant={{ priority: 'low' }}
                  disabled={!isFormTouched && !isQuoteApproved}
                >
                  {saveAndContinueLater}
                </Button>
              )}
              {!isFormValidated && !isVBP && (
                <Button
                  type="button"
                  onClick={e => onValidateForm(e)}
                  variant={{ priority: 'high' }}
                  disabled={isSubmitting}
                >
                  {continueButton}
                </Button>
              )}
              {isFormValidated && isVBP && !isSalesSupport && (
                <Button
                  type="button"
                  onClick={e => onSubmitForApproval(e)}
                  variant={{ priority: 'high' }}
                  disabled={isSubmitting}
                >
                  {submitForApproval}
                </Button>
              )}
            </Flex>
          </ButtonsWrapper>
        )}
      </>
    </div>
  );
};

Desktop.propTypes = {
  isVBP: PropTypes.bool.isRequired,
  isSendToSRT: PropTypes.bool.isRequired,
  isFormTouched: PropTypes.bool.isRequired,
  isFormValidated: PropTypes.bool.isRequired,
  isOrderFulfillmentTeam: PropTypes.bool.isRequired,
  isSalesSupport: PropTypes.bool.isRequired,
  dueMonthly: PropTypes.string.isRequired,
  dueNow: PropTypes.string.isRequired,
  onDownloadClick: PropTypes.func.isRequired,
  onProceedClick: PropTypes.func.isRequired,
  onValidateForm: PropTypes.func.isRequired,
  onSendToSRT: PropTypes.func.isRequired,
  onSaveAndExit: PropTypes.func.isRequired,
  onSubmitForApproval: PropTypes.func.isRequired,
  hidePricing: PropTypes.bool.isRequired,
  isQuoteApproved: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool
};

export default Desktop;
